// extracted by mini-css-extract-plugin
module.exports = {"uploadButton":"ItemImageUpload_uploadButton__2oucD","uiMealPopupImg":"ItemImageUpload_uiMealPopupImg__3gaYj","uiBtnCamera":"ItemImageUpload_uiBtnCamera__1s2rS"};